var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:"ladda",attrs:{"id":"ladda-button","data-style":_vm.dataStyle,"data-size":_vm.dataSize},on:{"click":_vm.handleClick}},[_c('span',{attrs:{"id":"ladda-menu-button"}},[_vm._t("default",function(){return [_vm._v("Submit")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }